module.exports = __webpack_public_path__ + "img/01n.8455ce5e.png";